<template>
  <div>
    <h1 v-if="name" class="mb-3 has-text-weight-bold is-size-5">{{ name }}</h1>
    <b-tabs v-model="activeTab" type="is-boxed">
      <b-tab-item label="CMS"><CMSEdit :channel-list.sync="channelList" @setName="setName" /></b-tab-item>
      <b-tab-item label="Спектры скорости"><VelEdit :agent-id="id" :channels="channelList" /></b-tab-item>
      <b-tab-item label="Спектры ускорения"><AccEdit :agent-id="id" :channels="channelList" /></b-tab-item>
      <b-tab-item label="Спектры огибающей"><EnvEdit :agent-id="id" :channels="channelList" /></b-tab-item>
      <b-tab-item label="Настройка температуры"><TemperatureEdit :agent-id="id" :channels="channelList" :is-active="activeTab === 4" /></b-tab-item>
      <b-tab-item label="Watchdogs"><WatchdogEdit :agent-id="id" :channels="channelList" :is-active="activeTab === 5" /></b-tab-item>
      <b-tab-item label="Minions"><MinionEdit :agent-id="id" :channels="channelList" :is-active="activeTab === 6" /></b-tab-item>
    </b-tabs>
  </div>
</template>

<script>
import "vue-advanced-cropper/dist/style.css";
import CMSEdit from "@/components/CMS/Sub-component/CMSEdit.vue"
import VelEdit from "@/components/CMS/Sub-component/VelEdit.vue"
import AccEdit from "@/components/CMS/Sub-component/AccEdit.vue"
import EnvEdit from "@/components/CMS/Sub-component/EnvEdit.vue"
import TemperatureEdit from "@/components/CMS/Sub-component/Temperature/TemperatureEdit.vue"
import WatchdogEdit from "@/components/CMS/Sub-component/Watchdog/WatchdogEdit.vue"
import MinionEdit from "@/components/CMS/Sub-component/Minion/MinionEdit.vue"

export default {
  components: { MinionEdit, WatchdogEdit, TemperatureEdit, EnvEdit, AccEdit, VelEdit, CMSEdit },
  props: ['id'],
  data() {
    return {
      channelList: [],
      activeTab: 0,
      name: ""
    };
  },
  methods: {
    setName(event) {
      this.name = event
    }
  }
};
</script>
